// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__D4RXM","left":"Header_left__jtvGf","right":"Header_right__BiQDz"};